import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
import { defineComponent, ref, onBeforeMount, reactive, watch, nextTick, onMounted, openBlock, createBlock, Teleport, createElementVNode, normalizeClass, unref, normalizeStyle, renderSlot, createElementBlock, Fragment, createTextVNode, toDisplayString, createVNode } from 'vue';
import { useStyleConfig } from '../abstract';
import { CloseOutlined } from '@ant-design/icons-vue';
var _hoisted_1 = ["innerHTML"];
var defaultContainerId = '#alertMessage';
var _sfc_main = /*#__PURE__*/defineComponent({
  __name: 'AlertMessage',
  props: {
    getContainer: {
      type: Function
    },
    message: String,
    duration: {
      type: Number,
      default: 1000
    },
    renderRaw: Boolean,
    container: {
      type: String,
      default: 'body'
    }
  },
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var props = __props;
    var _useStyleConfig = useStyleConfig('alert-message'),
      prefixCls = _useStyleConfig.prefixCls;
    var messageContainer = ref();
    onBeforeMount(function () {
      var _props$getContainer;
      var div = document.createElement('div');
      div.id = defaultContainerId.slice(1);
      messageContainer.value = div;
      var container = (_props$getContainer = props.getContainer) === null || _props$getContainer === void 0 ? void 0 : _props$getContainer.call(props);
      var _cont = document.body;
      if (container) {
        _cont = _typeof(container) === 'object' ? container : document.querySelector(container);
      }
      _cont.prepend(messageContainer.value);
    });
    var _config2 = reactive({
      duration: 2000,
      renderRaw: false,
      container: undefined
    });
    /**
     * 更换挂载容器
     */
    watch(function () {
      return _config2.container;
    }, function (val) {
      if (val) {
        messageContainer.value.parentNode.removeChild(messageContainer.value);
        var _cont = _typeof(val) === 'object' ? val : document.querySelector(val);
        _cont.prepend(messageContainer.value);
      }
    });
    var _message = ref();
    var _renderRaw = ref();
    var _type = ref('info');
    __expose({
      show: function show(message, type) {
        var renderRaw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _config2.renderRaw;
        var duration = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : _config2.duration;
        _type.value = type;
        _message.value = message;
        _renderRaw.value = renderRaw;
        marginTop.value = 0;
        setHidden(duration);
        return forceHide;
      },
      config: function config(_config) {
        if (_config.duration) {
          _config2.duration = _config.duration;
        }
        if (_config.renderRaw !== undefined) {
          _config2.renderRaw = _config.renderRaw;
        }
        if (_config.container) {
          _config2.container = _config.container;
        }
      }
    });
    function setHidden() {
      var millSeconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : props.duration;
      if (millSeconds > 0) {
        clearInterval(interval);
        interval = setTimeout(forceHide, millSeconds);
      }
    }
    var interval = undefined;
    var marginTop = ref(-26);
    var alert = ref();
    function forceHide() {
      clearInterval(interval);
      _renderRaw.value = undefined;
      _message.value = undefined;
      nextTick(function () {
        marginTop.value = -alert.value.scrollHeight;
      });
    }
    onMounted(function () {
      if (!_message.value) {
        marginTop.value = -alert.value.scrollHeight;
      }
    });
    return function (_ctx, _cache) {
      return openBlock(), createBlock(Teleport, {
        to: messageContainer.value
      }, [createElementVNode("div", {
        ref_key: "alert",
        ref: alert,
        class: normalizeClass("".concat(unref(prefixCls), " ").concat(unref(prefixCls), "-").concat(_type.value)),
        style: normalizeStyle("margin-top: ".concat(marginTop.value, "px;"))
      }, [createElementVNode("div", {
        class: normalizeClass("".concat(unref(prefixCls), "-content"))
      }, [renderSlot(_ctx.$slots, "default", {}, function () {
        var _ref2, _renderRaw$value, _message$value, _message$value2;
        return [((_ref2 = (_renderRaw$value = _renderRaw.value) !== null && _renderRaw$value !== void 0 ? _renderRaw$value : __props.renderRaw) !== null && _ref2 !== void 0 ? _ref2 : _config2.renderRaw) ? (openBlock(), createElementBlock("div", {
          key: 0,
          innerHTML: (_message$value = _message.value) !== null && _message$value !== void 0 ? _message$value : __props.message
        }, null, 8 /* PROPS */, _hoisted_1)) : (openBlock(), createElementBlock(Fragment, {
          key: 1
        }, [createTextVNode(toDisplayString((_message$value2 = _message.value) !== null && _message$value2 !== void 0 ? _message$value2 : __props.message), 1 /* TEXT */)], 64 /* STABLE_FRAGMENT */))];
      })], 2 /* CLASS */), createVNode(unref(CloseOutlined), {
        class: normalizeClass("".concat(unref(prefixCls), "-close-icon")),
        onClick: forceHide
      }, null, 8 /* PROPS */, ["class"])], 6 /* CLASS, STYLE */)], 8 /* PROPS */, ["to"]);
    };
  }
});
var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var AlertMessage = /* @__PURE__ */_export_sfc(_sfc_main, [["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/alert-message/AlertMessage.js"]]);
export { AlertMessage as default };